<ng-template #aplBlockUi>
    <p-button
        [pTooltip]="
            !checkIfCanSave()
                ? ('address.save-address-first' | translate)
                : ('address.missing-data-for-save' | translate)
        "
        [loading]="isSaving"
        icon="fa fa-save"
        [label]="'address.save-address-first' | translate"
        [disabled]="checkIfCanSave()"
        (onClick)="saveToUnlockEditMode()"
    ></p-button>
</ng-template>

<blockable-div #aplBlock [blocked]="!model.id" [blockUi]="aplBlockUi">
    @if (model.id) {
        <app-widget-address-postal-links-list
            #addressPostalLinksList
            [autoFocusSearch]="false"
            [addressId]="model.id"
        />
    }
</blockable-div>
